import {useState} from "react";
import {useTranslation} from "react-i18next";
import {SubmissionTranslKey} from "./SubmissionTranslKey";
import {SubmissionDto} from "../../client/submission/SubmissionApiClient";
import {DetailActionButton} from "../../common/button/CommonActionButtons";
import SubmissionSearchPanel from "./search/SubmissionSearchPanel";
import SubmissionDetailDialog from "./SubmissionDetailDialog";
import Page from "../../common/page/Page";
import UserRoleResolver from "../user/UserRoleResolver";
import {useUserRoles} from "../user/UserContext";

export interface SubmissionPageProps {
    isAdminOverview: boolean;
}

export function SubmissionPage(props: Readonly<SubmissionPageProps>) {
    const {isAdminOverview} = props;

    const [selectedSubmission, setSelectedSubmission] = useState<SubmissionDto>();
    const {t} = useTranslation();

    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const [detailSubmissionId, setDetailSubmissionId] = useState<number>();

    const pageTitle = isAdminOverview ? t(SubmissionTranslKey.DOCUMENTS_MANAGEMENT) : t(SubmissionTranslKey.RECEIVED_DOCUMENTS);

    const userRoles = useUserRoles();
    const anonymizePersonNames = isAdminOverview && UserRoleResolver.isOperator(userRoles);

    function showDetailDialog(submissionId: number) {
        setDetailSubmissionId(submissionId);
        setDetailDialogOpen(true);
    }

    function onDetailDialogClose() {
        setDetailDialogOpen(false)
    }

    function onSubmissionSelected(submission?: SubmissionDto) {
        setSelectedSubmission(submission);
    }

    const actions: React.ReactNode = (
        <>
            <DetailActionButton onClick={() => showDetailDialog(selectedSubmission!.id)}
                                disabled={!selectedSubmission}/>
        </>
    );

    return (
        <>
            <Page title={pageTitle}>
                <SubmissionSearchPanel actions={actions}
                        isAdminOverview={isAdminOverview}
                        anonymizePersonNames={anonymizePersonNames}
                        onSelectedSubmission={onSubmissionSelected}
                        onSubmissionDoubleClick={showDetailDialog} />
            </Page>

            <SubmissionDetailDialog open={detailDialogOpen}
                    onClose={onDetailDialogClose}
                    submissionId={detailSubmissionId}
                    anonymizePersonNames={anonymizePersonNames} />
        </>
    );
}
